const points = [
  {
    icon: 'ri-global-line',
    title: 'Cea Mai Mare Piață din Lume',
    desc: 'Cu un volum zilnic de peste 6 trilioane de dolari, piața Forex depășește toate bursele de valori combinate. Funcționează non-stop, 5 zile pe săptămână.',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: 'Ce Se Tranzacționează?',
    desc: 'În Forex, tranzacționezi perechi valutare — spre exemplu EUR/USD înseamnă că schimbi Euro contra Dolar American. Prețul fluctuează constant în funcție de economia globală.',
  },
  {
    icon: 'ri-user-2-line',
    title: 'Cine Participă?',
    desc: 'Bănci centrale, corporații multinaționale, fonduri de investiții și traderi individuali — toți contribuie la lichiditatea acestei piețe imense.',
  },
  {
    icon: 'ri-time-line',
    title: 'Piața 24/5',
    desc: 'Forex-ul este deschis de luni dimineață (Sydney) până vineri seara (New York), acoperind toate fusurile orare. Poți tranzacționa oricând ți se potrivește.',
  },
];

export default function Introducere() {
  return (
    <section id="introducere" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <span
              className="inline-block text-sm font-semibold uppercase tracking-widest mb-4 px-4 py-1 rounded-full"
              style={{ background: 'rgba(78,205,196,0.12)', color: '#4ecdc4' }}
            >
              01 — Introducere
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold leading-tight mb-6"
              style={{ fontFamily: 'Playfair Display, serif', color: '#0f1419' }}
            >
              Ce Este Piața <br />
              <span style={{ color: '#4ecdc4' }}>Forex</span>?
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg mb-6">
              Forex (Foreign Exchange) este piața globală pentru schimbul valutelor. Spre deosebire de burse, Forex nu are o locație fizică centrală — este o rețea globală descentralizată de bănci, brokeri și traderi individuali.
            </p>
            <p className="text-gray-500 leading-relaxed">
              Pentru un începător, Forex poate părea intimidant — dar cu educația potrivită, oricine poate înțelege cum funcționează și poate lua decizii informate de tranzacționare.
            </p>
          </div>

          {/* Visual card */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '16/10' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/d5ed03261689194b98897cacdc103ce4.jpg"
                alt="Piața globală Forex"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(15,20,25,0.7) 0%, transparent 60%)' }}></div>
              <div className="absolute bottom-5 left-5 right-5">
                <div className="flex items-center gap-6 flex-wrap">
                  <div className="text-center">
                    <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>$6T</p>
                    <p className="text-xs text-gray-300">Volum Zilnic</p>
                  </div>
                  <div className="w-px h-10 bg-white/30"></div>
                  <div className="text-center">
                    <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>24/5</p>
                    <p className="text-xs text-gray-300">Piată Deschisă</p>
                  </div>
                  <div className="w-px h-10 bg-white/30"></div>
                  <div className="text-center">
                    <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>180+</p>
                    <p className="text-xs text-gray-300">Monede</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Badge */}
            <div className="absolute top-4 right-4 bg-white rounded-full px-4 py-2 text-xs font-semibold shadow-lg flex items-center gap-2" style={{ color: '#0f1419' }}>
              <i className="ri-map-pin-line" style={{ color: '#4ecdc4' }}></i>
              Piața Globală
            </div>
          </div>
        </div>

        {/* Points grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {points.map((p, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl border border-gray-100 transition-all duration-300 hover:-translate-y-1 group cursor-default"
              style={{ background: '#fafaf9' }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-4 transition-colors duration-300"
                style={{ background: 'rgba(78,205,196,0.12)' }}
              >
                <i className={`${p.icon} text-xl`} style={{ color: '#4ecdc4' }}></i>
              </div>
              <h3 className="font-bold text-base mb-2" style={{ color: '#0f1419' }}>{p.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
